<template>
	<div class="container">
		<header class="header">
			<router-link :to="{ path: '/easyq/' }" class="title">
				<i class="fa fa-chevron-left" aria-hidden="true"></i>
				{{ $t('backBtn') }}
			</router-link>
			<Lang />
		</header>
		<section class="map">
			<div id="map" class="map">
				<l-map v-if="showMap" :zoom="zoom" :center="center" :options="mapOptions" style="height: 100%">
					<l-tile-layer :url="url" :attribution="attribution" />
					<l-marker :lat-lng="getCoord(item.BranchCoordinates.Latitude, item.BranchCoordinates.Longitude)"
						v-for="item in coordArray" :key="item.id">
						<l-popup>
							<div class="mapPopup">
								<h1>{{ item.BranchName }}</h1>
								<p>- {{ item.BranchAddress }}</p>
								<h2>{{ $t('workingHours') }}</h2>

								<table>
									<tr>
										<th>{{ $t('monday') }}</th>
										<th>{{ $t('tuesday') }}</th>
										<th>{{ $t('wednesday') }}</th>
										<th>{{ $t('thursday') }}</th>
										<th>{{ $t('friday') }}</th>
										<th>{{ $t('saturday') }}</th>
										<th>{{ $t('sunday') }}</th>
									</tr> <!--ряд с ячейками заголовков-->
									<tr>
										<td v-for="i in item.BranchOpenHours" :key="i.index">{{ i.Time }}</td>
									</tr> <!--ряд с ячейками тела таблицы-->
								</table>

								<router-link v-if="settings.booking === 'on'"
									:to="{ name: 'Booking', params: { id: item.BranchId, lang: $route.params.lang, metod: 'booking' } }"
									class="mapPopup__link">{{ $t('homeBtnOne') }}</router-link>
								<router-link v-if="settings.eticket === 'on'"
									:to="{ name: 'ETicket', params: { id: item.BranchId, lang: $route.params.lang, metod: 'e-ticket' } }"
									class="mapPopup__link">{{ $t('homeBtnTwo') }}</router-link>
							</div>
						</l-popup>
					</l-marker>
				</l-map>
			</div>
		</section>
		<NotFound />
	</div>
</template>

<script>
import Lang from "@/components/Lang.vue"
import NotFound from '@/components/NotFound.vue'
import axios from 'axios'
import { Icon, latLng } from "leaflet"
import { LMap, LMarker, LPopup, LTileLayer } from "vue2-leaflet"

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
	iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
	iconUrl: require("leaflet/dist/images/marker-icon.png"),
	shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
})
export default {
	data() {
		return {
			zoom: 7,
			center: latLng(41.312452, 69.253328),
			url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			attribution:
				'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
			mapOptions: {
				zoomSnap: 0.5
			},
			showMap: true,
			coordArray: [],
			settings: '',
			// booking: 'on',
			// eticket: 'on',
			deviceId: ''
		}
	},
	components: {
		LMap,
		LTileLayer,
		LMarker,
		LPopup,
		Lang,
		NotFound
	},
	beforeMount() {
		const deviceId = localStorage.getItem('deviceId')
		const deviceNumber = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2)
		if (deviceId == null || deviceId == undefined) {
			localStorage.setItem('deviceId', deviceNumber)
		} else if (deviceId != '') {
			this.deviceId = deviceId
		} else {
			this.deviceId = deviceNumber
			localStorage.setItem('deviceId', deviceNumber)
		}
	},
	mounted() {
		this.loading()
		this.$i18n.locale = this.$route.params.lang
		this.mapСoordinates()
	},
	methods: {
		async mapСoordinates() {
			// await axios
			//   .get(this.settings.api + '/ListBranches')
			//   .then(response => (this.coordArray = response.data))
			//   .catch((error) => console.log(error))
			await axios
				.get(this.settings.apiBookingBarakaTexnika + '/Branches/ListBranches')
				.then(response => {
					// for (let index = 0; index < response.data.length; index++) {
					//   this.coordArray.push(response.data[index])
					// }
					this.coordArray = response.data
				})
				.catch((error) => console.log(error));
		},
		getCoord(a, b) {
			return latLng(a, b)
		},
		loading() {
			this.settings = window.MY_CONFIG_EASYQ
		}
	}
}
</script>
